import request from '@/utils/request'

// 返回初始账号登录
export function switchBack(data) {
  return request({
    url: `/switch_back`,
    method: 'post',
    data
  })
}
